import * as React from "react"
import pillSticker from "@/public/stickers/pill.webm"

// ─── Sticker Registry ────────────────────────────────
export interface StickerDef {
  id: string
  name: string
  src: string
}

export const STICKERS: StickerDef[] = [
  { id: "pill", name: "Pill", src: pillSticker },
]

const stickerMap = new Map(STICKERS.map((s) => [s.id, s]))

export function getStickerSrc(stickerId: string): string | undefined {
  return stickerMap.get(stickerId)?.src
}

// ─── Picker Component ────────────────────────────────
interface StickerPickerProps {
  onSelect: (stickerId: string) => void
  onClose: () => void
}

export function StickerPickerContent({ onSelect, onClose }: StickerPickerProps) {
  return (
    <div
      className="w-[280px] bg-[#1C1C32] border-3 border-[#2A2A45] rounded-2xl shadow-[6px_6px_0_0_#1a1a1a] overflow-hidden"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="px-3 py-2 border-b-2 border-[#2A2A45]/40">
        <p className="text-xs font-black text-[#9A9ABF] uppercase tracking-wider">Stickers</p>
      </div>

      <div className="p-2 grid grid-cols-2 gap-2 max-h-[300px] overflow-y-auto">
        {STICKERS.map((sticker) => (
          <button
            key={sticker.id}
            onClick={() => {
              onSelect(sticker.id)
              onClose()
            }}
            className="group relative aspect-square rounded-xl border-2 border-transparent hover:border-[#F37020] bg-[#1A1A30] hover:bg-[#F37020]/5 transition-all overflow-hidden"
          >
            <video
              src={sticker.src}
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-contain p-2 group-hover:scale-110 transition-transform"
            />
          </button>
        ))}
      </div>
    </div>
  )
}
